import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-histogram_single",
  "use": "icon-histogram_single-usage",
  "viewBox": "0 0 100 100.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 100.3\" id=\"icon-histogram_single\">\r\n<rect x=\"2.5\" y=\"56.3\" width=\"17\" height=\"32\" />\r\n<rect x=\"22\" y=\"34.5\" width=\"17\" height=\"53.8\" />\r\n<rect x=\"41.4\" y=\"45.7\" width=\"17\" height=\"42.7\" />\r\n<rect x=\"60.9\" y=\"25.2\" width=\"17\" height=\"63.3\" />\r\n<rect x=\"80.3\" y=\"11.8\" width=\"17\" height=\"76.7\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/histogram_single.svg
// module id = +fOX
// module chunks = 102